import { ComponentInstall } from "../../utils";
import Drawer from "./src";

export default ComponentInstall(Drawer);
